
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import VehicleInspection from "./pages/VehicleInspection";
import AdminECardPromosPage from "./pages/AdminECardPromosPage";
import AdminECardCardsPage from "./pages/AdminECardCardsPage";
import AdminECardDrawsPage from "./pages/AdminECardDrawsPage";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PWAUpdatePrompt from "./components/PWAUpdatePrompt";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider defaultTheme="light">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/vehicle-inspection" element={<VehicleInspection />} />
            <Route path="/admin/ecard-promos" element={<AdminECardPromosPage />} />
            <Route path="/admin/ecard-cards" element={<AdminECardCardsPage />} />
            <Route path="/admin/ecard-draws" element={<AdminECardDrawsPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>

        <PWAInstallPrompt />
        <PWAUpdatePrompt />
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
